import Button from "@/components/Button";
import { SVGArrowRight } from "@/lib/svg";
import { useTranslation } from "@/lib/translations";
import Link from "next/link";
import { useRouter } from "next/router";

export type NextButtonProps = {
  slug: string;
};

const NextButton: React.FC<NextButtonProps> = ({ slug }) => {
  const { locale = "it" } = useRouter();
  const label = useTranslation("articlePage.nextArticle", locale);
  return (
    <Link href={"/news/" + slug} passHref>
      <Button as="a" variant="primaryBoxed" icon={<SVGArrowRight />}>
        {label || "Prossimo articolo"}
      </Button>
    </Link>
  );
};

export default NextButton;
